import { gql } from '@apollo/client';
const GET_SPECIFICATION_COMPONENT_CONSUMPTIONS = gql `
  query GetSpecificationComponentConsumptions($modelSpecificationId: ID!) {
    node(id: $modelSpecificationId) {
      ... on ModelSpecificationNode {
        id
        components {
          edges {
            node {
              id
              name
              consumptionVariedOnSize
              consumptions {
                edges {
                  node {
                    id
                    consumption
                    modelSpecificationSize {
                      id
                      sizeName {
                        id
                        name
                      }
                    }
                  }
                }
              }
              productCategory {
                id
                type
                typeLabelPL
                typeLabelEN
                typeIcon
                consumptionType {
                  id
                  name
                  labelPL
                  labelEN
                  integerValues
                }
              }
            }
          }
        }
      }
    }
  }
`;
export default GET_SPECIFICATION_COMPONENT_CONSUMPTIONS;
